import type { CSS } from '@grupoboticario/flora-react'

export const outerBoxCss: CSS = {
  margin: '$7 0 $5'
}
